import { Grid, styled as muiStyled } from '@mui/material'

export const SummaryCard = muiStyled('div')(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
  boxShadow:
    theme.palette.mode === 'light'
      ? '0 2px 8px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)'
      : '0 2px 12px rgba(0,0,0,0.3)',
}))

export const SummaryHeader = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 2.5),
  background:
    theme.palette.mode === 'light'
      ? `linear-gradient(180deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`
      : theme.palette.grey[900],
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const SummaryHeaderContent = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  flex: 1,
  minWidth: 0,
}))

export const SummaryBody = muiStyled('div')(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  background: theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.background.default,
}))

export const SummaryGrid = muiStyled(Grid)(({ theme }) => ({
  padding: 0,
  gap: theme.spacing(2),
}))

export const SummaryBlock = muiStyled('div')(({ theme }) => ({
  height: '100%',
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  background: theme.palette.background.paper,
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    borderColor: theme.palette.divider,
  },
}))

export const SummaryBlockLabel = muiStyled('div')(({ theme }) => ({
  fontSize: '0.6875rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1.5),
  paddingBottom: theme.spacing(0.75),
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const SummaryKVRow = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
  padding: theme.spacing(0.75, 0),
  '&:first-of-type': {
    paddingTop: 0,
  },
  '&.summary-kv-highlight': {
    paddingTop: theme.spacing(1.25),
    marginTop: theme.spacing(0.75),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  '& .summary-label': {
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  '& .summary-value': {
    fontSize: '0.9375rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    letterSpacing: '0.02em',
  },
  '& .summary-value--primary': {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  '& .summary-value--large': {
    fontSize: '1.0625rem',
    fontWeight: 600,
  },
}))

/** Right-side settlement callout */
export const SettlementCallout = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.5, 3),
  minWidth: 220,
  minHeight: 140,
  borderRadius: 16,
  textAlign: 'center',
  background:
    theme.palette.mode === 'light'
      ? `linear-gradient(145deg, ${theme.palette.primary.main}0c 0%, ${theme.palette.primary.dark}14 100%)`
      : theme.palette.grey[900],
  border: `1px solid ${theme.palette.primary.main}40`,
  boxShadow: `0 2px 12px ${theme.palette.primary.main}15`,
  '& .settlement-caption': {
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
  },
  '& .settlement-amount': {
    fontSize: '1.5rem',
    fontWeight: 800,
    color: theme.palette.primary.main,
    letterSpacing: '0.02em',
    lineHeight: 1.2,
  },
}))

/** Wrapper for the 5th card (Settlement/Collection) – highlighted and visually separate */
export const CollectionCardWrapper = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  borderRadius: 16,
  background:
    theme.palette.mode === 'light'
      ? `linear-gradient(180deg, ${theme.palette.primary.main}0c 0%, ${theme.palette.primary.main}06 100%)`
      : theme.palette.grey[900],
  border: `2px solid ${theme.palette.primary.main}`,
  boxShadow: `0 4px 20px ${theme.palette.primary.main}28`,
  '& .collection-card-label': {
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
}))

